import React, { useState, useEffect } from 'react';
import CongratulationCard from './CongratulationCard';
import WelcomeSlide from './WelcomeSlide';
import './App.css';
import { congratulations } from './data';
import confetti from 'canvas-confetti';

function App() {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState('next');
  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);
  const [bgAudio, setBgAudio] = useState(null);
  const [isMusicPlaying, setIsMusicPlaying] = useState(false);

  useEffect(() => {
    const bg = new Audio("/audio/favorite_song.mp3");
    bg.loop = true;
    bg.volume = 1;
    setBgAudio(bg);
  }, []);

  const toggleMusic = () => {
    if (!bgAudio) return;
    if (isMusicPlaying) {
      bgAudio.pause();
      setIsMusicPlaying(false);
    } else {
      bgAudio.play().catch(() => {});
      setIsMusicPlaying(true);
    }
  };

  const handleVoiceToggle = (audioRef) => {
    const audio = audioRef?.current;
    if (!audio) return;

    // Остановить все другие аудио
    document.querySelectorAll('audio').forEach((a) => {
      if (a !== audio) {
        a.pause();
        a.currentTime = 0;
      }
    });

    // Управление текущим
    if (audio.paused) {
      audio.load();
      audio.play().catch(() => {});
      if (bgAudio && isMusicPlaying) bgAudio.volume = 0.2;
    } else {
      audio.pause();
      audio.currentTime = 0;
      if (bgAudio && isMusicPlaying) bgAudio.volume = 1;
    }
  };

  const allSlides = [
    { type: 'welcome' },
    ...congratulations.map(congratulation => ({
      type: 'congratulation',
      congratulation,
    })),
  ];

  const triggerConfetti = () => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });
  };

  const handleSwipe = (direction) => {
    // Остановить любые голосовые при переходе
    document.querySelectorAll('audio').forEach((a) => {
      a.pause();
      a.currentTime = 0;
    });
    if (bgAudio && isMusicPlaying) bgAudio.volume = 1;

    setSlideDirection(direction);
    triggerConfetti();

    setCurrentSlideIndex((prevIndex) => {
      let newIndex = direction === 'next' ? prevIndex + 1 : prevIndex - 1;
      if (newIndex < 0) newIndex = allSlides.length - 1;
      else if (newIndex >= allSlides.length) newIndex = 0;
      return newIndex;
    });
  };

  const handleSwipeDown = () => handleSwipe('next');
  const handleSwipeUp = () => handleSwipe('prev');

  const handleTouchStart = (e) => setTouchStartY(e.touches[0].clientY);
  const handleTouchMove = (e) => setTouchEndY(e.touches[0].clientY);
  const handleTouchEnd = () => {
    if (touchStartY === null || touchEndY === null) return;
    const deltaY = touchStartY - touchEndY;
    if (deltaY > 20) handleSwipeDown();
    else if (deltaY < -20) handleSwipeUp();
    setTouchStartY(null);
    setTouchEndY(null);
  };

  const currentSlide = allSlides[currentSlideIndex];

  return (
    <div
      className="app-container"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className={`slide-container ${slideDirection}`}>
        {currentSlide?.type === 'welcome' && <WelcomeSlide />}
        {currentSlide?.type === 'congratulation' && (
          <CongratulationCard
            personName={currentSlide.congratulation.personName}
            voiceMessage={currentSlide.congratulation.voiceMessage}
            sticker={currentSlide.congratulation.sticker}
            quote={currentSlide.congratulation.quote}
            onVoiceToggle={handleVoiceToggle}
          />
        )}
      </div>

      <div className="nav-buttons">
        <button onClick={handleSwipeUp}>⬆️</button>
        <button onClick={handleSwipeDown}>⬇️</button>
      </div>

      <button className="music-toggle-button" onClick={toggleMusic}>
        {isMusicPlaying ? '⏸ Остановить музыку' : '🎵 Включить музыку'}
      </button>
    </div>
  );
}

export default App;
